import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import {Helmet} from "react-helmet";

import './ContactUs.css';

export default class ContactUs extends Component {
    render() {
        return (
            <div className="contact-us">
                <Helmet>
                    <title>Contact Us - HelloAva</title>
                    <meta name="description" content="Do you have questions about how HelloAva works, or want to know more about how to build your ideal skin care routine?" />
                </Helmet>
                <div className="big-message">Contact Us</div>
                <div className="inline">
                    <div className="small-message">For press inquiries, e-mail</div>
                    <a href="mailto:press@helloava.co">press@helloava.co</a>
                </div>
                <div className="inline">
                    <div className="small-message">For any customer inquiries, please contact</div>
                    <a href="mailto:customersuccess@helloava.co">customersuccess@helloava.co</a>
                </div>
                <div className="inline">
                    <div className="small-message">For social media and influencer inquires, please e-mail</div>
                    <a href="mailto:socialmedia@helloava.co">socialmedia@helloava.co</a>
                </div>
                <div className="inline">
                    <div className="small-message">For partnership and brand inquiries, please e-mail</div>
                    <a href="mailto:partnership@helloava.co">partnership@helloava.co</a>
                </div>
                <div className="inline">
                    <div className="small-message">Text us at </div>
                    <a href="tel:1-646-461-3310">(646) 461-3310</a>
                </div>
                <div className="small-message note">(If you are an existing user of HelloAva and have a skincare-related question, just text us back in the same SMS channel. Our skin advisors will get back to you shortly.)</div>
                <div className="small-message">511 AVENUE OF THE AMERICAS # 4011 NEW YORK</div>
                <div className="small-message">New York, NY 10011</div>

                <div className="big-message">Follow us & get inspired!</div>
                <div className="icons">
                    <a href="https://www.instagram.com/helloavabeauty/" target="_blank" rel="noopener noreferrer">
                        <div className="icon-wrapper">
                            <ReactSVG path="/images/common/instagram.svg" wrapperClassName="svg-wrapper" />
                        </div>
                    </a>
                    <a href="https://m.me/helloavabeauty" target="_blank" rel="noopener noreferrer">
                        <div className="icon-wrapper">
                            <ReactSVG path="/images/common/facebook.svg" style={{ width: '26px' }} wrapperClassName="svg-wrapper" />
                        </div>
                    </a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/contactus/ContactUs.js